import React from 'react';
import { usePracticeData } from '@components/PracticeV2/Provider/PracticeDataProvider';
import { usePractice } from '@components/PracticeV2/Provider/PracticeProvider';
import { PracticeState } from '@components/PracticeV2/types';
import PracticeTopNavBar from '../PracticeTopNavBar';
import { GroupSheetContainer, SkipLink, PracticeMain } from './PracticeLayout.style';
import usePracticeGoBack from '../../hooks/usePracticeGoBack';
import IndividualWaitingDialog from '../IndividualWaitingDialog';
import PracticeWizard from '../PracticeWizard';
import GroupModeStartDialog from '../GroupModeStartDialog';
import PracticeContent from '../PracticeContent';
import { TrayProvider } from '@components/Atoms/ResizableTray/TrayProvider';
import VisuallyHidden from '@components/Atoms/VisuallyHidden/VisuallyHidden';

// note : PracticeTopNavBar status is a modification that we will make it static for now
// it will fire a toast on status 1 or 2

const PracticeLayout = () => {
  const goBack = usePracticeGoBack();
  const { duration, individualDuration, startedDate } = usePracticeData();
  const { state, handleTimeOut } = usePractice();
  return (
    <TrayProvider>
      <GroupSheetContainer>
        <SkipLink href="#practice-main-content">Skip to main content</SkipLink>
        <PracticeTopNavBar
          goBack={goBack}
          onTimeOut={handleTimeOut}
          duration={
            state.practiceState === PracticeState.Individual ? individualDuration : duration
          }
          startTime={startedDate}
        />
        <PracticeMain id="practice-main-content" tabIndex={-1}>
          <VisuallyHidden as="h1">Group Activity Practice</VisuallyHidden>
          <PracticeContent />
          <PracticeWizard />
          <IndividualWaitingDialog />
          <GroupModeStartDialog />
        </PracticeMain>
      </GroupSheetContainer>
    </TrayProvider>
  );
};

export default React.memo(PracticeLayout);
